/* unplugin-vue-components disabled */import { render } from "./status-badge.vue?vue&type=template&id=454b9544&scoped=true"
import script from "./status-badge.vue?vue&type=script&lang=js"
export * from "./status-badge.vue?vue&type=script&lang=js"

import "./status-badge.vue?vue&type=style&index=0&id=454b9544&scoped=true&lang=css"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454b9544"],['__file',"src/pages/sh-files/status-badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "454b9544"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('454b9544', __exports__)) {
    api.reload('454b9544', __exports__)
  }
  
  module.hot.accept("./status-badge.vue?vue&type=template&id=454b9544&scoped=true", () => {
    api.rerender('454b9544', render)
  })

}


export default __exports__